import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import { ValidationCons } from "../../validation/validationConstant";
import { updateImmigrationDetails } from "../../service/apis/jobseeker.api";
import { showError } from "../../utils/Common";

import { countries, languages } from "countries-list";
import countries2to3 from "countries-list/minimal/countries.2to3.min.json";
import { updateImmigration } from "../../store/auth.store";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";

interface ImmigrationState {
  rq_im: any;
}

interface AuthState {
  user: any;
  education: any[];
  experience: any[];
}

interface RootState {
  immigrationSlice: ImmigrationState;
  authSlice: AuthState;
}

const RequestImmigrationFormScreen = () => {
  const [NavigateTo] = useCustomNavigate();

  const { rq_im } = useSelector((state: RootState) => state.immigrationSlice);
  const { user } = useSelector((state: RootState) => state.authSlice);

  const dispatch = useDispatch();

  const [showSpouseName, setShowSpouseName] = useState(true);
  const [previouslyMarried, setPreviouslyMarried] = useState(false);
  const [haveGreenCard, setHaveGreenCard] = useState(false);
  const [havePostSecondaryEducation, setHavePostSecondaryEducation] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const RequestImmegrationik = useFormik({
    initialValues: {
      isResidentialSame: false,
      serviceIn: rq_im?.serviceIn || "English",
      visaRequested: rq_im?.visaRequested || "visitor visa",
      fullName: rq_im?.fullName || "",
      sex: rq_im?.sex || "F",
      dateOfBirth: rq_im?.dateOfBirth || "",
      placeOfBirth: rq_im?.placeOfBirth || "",
      countryOrTerritory: rq_im?.countryOrTerritory || "AND",
      citizenship: rq_im?.citizenship || "AND",
      currentCountry: rq_im?.currentCountry || "AND",
      citizenStatus: rq_im?.citizenStatus || "citizen",
      previousTerritoryDifferent: rq_im?.previousTerritoryDifferent || "no",
      maritialStatus: rq_im?.maritialStatus || "annulled marriage",
      spouseName: rq_im?.spouseName || "",
      previouslyMarried: rq_im?.previouslyMarried || "no",
      previousSpouseName: rq_im?.previousSpouseName || "",
      previousSpouseDob: rq_im?.previousSpouseDob || "",
      typeOfRelationship: rq_im?.typeOfRelationship || "common-law",
      previousSpouseFrom: rq_im?.previousSpouseFrom || "",
      previousSpouseTill: rq_im?.previousSpouseTill || "",
      languages: rq_im?.languages || "aa",
      communicationFrench: rq_im?.communicationFrench || "english",
      assessProficiency: rq_im?.assessProficiency || "",
      passportNumber: rq_im?.passportNumber || "",
      countryOfPassportIssued: rq_im?.countryOfPassportIssued || "AND",
      issueDate: rq_im?.issueDate || "",
      expiryDate: rq_im?.expiryDate || "",
      nationalDocumentNumber: rq_im?.nationalDocumentNumber || "",
      nationalDocumentIssuer: rq_im?.nationalDocumentIssuer || "AND",
      nationalDocumentIssueDate: rq_im?.nationalDocumentIssueDate || "",
      nationalDocumentExpiryDate: rq_im?.nationalDocumentExpiryDate || "",
      greenCard: rq_im?.greenCard || "",
      greenCardNumber: rq_im?.greenCardNumber || "",
      greenCardExpiry: rq_im?.greenCardExpiry || "",
      contactStreet: rq_im?.contactStreet || "",
      contactCity: rq_im?.contactCity || "",
      contactCountry: rq_im?.contactCountry || "AND",
      residentialAddressSame: rq_im?.residentialAddressSame || "",
      residentialStreet: rq_im?.residentialStreet || "",
      residentialCity: rq_im?.residentialCity || "",
      residentialCountry: "AND",
      telephone: rq_im?.telephone || "",
      contactType: rq_im?.contactType || "cellular",
      contactCountryCode: rq_im?.contactCountryCode || "",
      contactNumber: rq_im?.contactNumber || "",
      contactFax: rq_im?.contactFax || "",
      contactType2: rq_im?.contactType2 || "residence",
      contactCountryCode2: rq_im?.contactCountryCode2 || "AND",
      contactNumber2: rq_im?.contactNumber2 || "",
      contactEmail: user?.email || rq_im?.contactEmail,
      canadaVisitPurpose: rq_im?.canadaVisitPurpose || "business",
      canadaVisitedFrom: rq_im?.canadaVisitedFrom || "",
      canadaVisitedTill: rq_im?.canadaVisitedTill || "",
      fundsAvailableCAD: rq_im?.fundsAvailableCAD || "",
      nameInCanada: rq_im?.nameInCanada || "",
      addressInCanada: rq_im?.addressInCanada || "",
      educationSecondary: rq_im?.educationSecondary || "",
      educationStartedYear: rq_im?.educationStartedYear || "",
      educationStartedMonth: rq_im?.educationStartedMonth || "",
      educationTillYear: rq_im?.educationTillYear || "",
      educationTillMonth: rq_im?.educationTillMonth || "",
      fieldOfStudent: rq_im?.fieldOfStudent || "",
      schoolName: rq_im?.schoolName || "",
      schoolCity: rq_im?.schoolCity || "",
      schoolCountry: rq_im?.schoolCountry || "AND",
      employmentFromYear: rq_im?.employmentFromYear || "",
      employmentFromMonth: rq_im?.employmentFromMonth || "",
      employmentToYear: rq_im?.employmentToYear || "",
      employmentToMonth: rq_im?.employmentToMonth || "",
      currentOccupation: rq_im?.currentOccupation || "",
      currentCompanyName: rq_im?.currentCompanyName || "",
      currentCompanyCity: rq_im?.currentCompanyCity || "",
      currentCompanyCountry: rq_im?.currentCompanyCountry || "AND",
      tbInLast2Years: rq_im?.tbInLast2Years || "no",
      physicalMentalDisorder: rq_im?.physicalMentalDisorder || "no",
      nameOfFamilyMember: rq_im?.nameOfFamilyMember || "",
      withoutAuthorization: rq_im?.withoutAuthorization || "no",
      visaDenied: rq_im?.visaDenied || "no",
      previouslyApplied: rq_im?.previouslyApplied || "no",
      yes2abcDetials: rq_im?.yes2abcDetials || "",
      criminalOffence: rq_im?.criminalOffence || "no",
      criminalDetails: rq_im?.criminalDetails || "",
      militaryVoluntary: rq_im?.militaryVoluntary || "no",
      detailsVoluntaryServed: rq_im?.detailsVoluntaryServed || "",
      associatedWithPoliticalParty: rq_im?.associatedWithPoliticalParty || "no",
      witnessedCivilians: rq_im?.witnessedCivilians || "no",
    },
    validationSchema: yup.object({
      serviceIn: yup
        .string()
        .trim()
        .required(ValidationCons.SERVICEIN_REQUIRED),
      visaRequested: yup
        .string()
        .trim()
        .required(ValidationCons.VISAREQUESTED_REQUIRED),
      fullName: yup.string().trim().required(ValidationCons.FULLNAME_REQUIRED),
      sex: yup.string().trim().required(ValidationCons.SEX_REQUIRED),
      dateOfBirth: yup
        .string()
        .trim()
        .required(ValidationCons.DATEOFBIRTH_REQUIRED),
      placeOfBirth: yup.string().trim().optional(),
      // .required(ValidationCons.PLACEOFBIRTH_REQUIRED),
      countryOrTerritory: yup
        .string()
        .trim()
        .required(ValidationCons.COUNTRYORTERRITORY_REQUIRED),
      citizenship: yup
        .string()
        .trim()
        .required(ValidationCons.CITIZENSHIP_REQUIRED),
      currentCountry: yup
        .string()
        .trim()
        .required(ValidationCons.CURRENTCOUNTRY_REQUIRED),
      citizenStatus: yup
        .string()
        .trim()
        .required(ValidationCons.CITIZENSTATUS_REQUIRED),
      previousTerritoryDifferent: yup
        .string()
        .trim()
        .required(ValidationCons.PREVIOUSTERRITORYDIFFERENT_REQUIRED),
      maritialStatus: yup
        .string()
        .trim()
        .required(ValidationCons.MARITIALSTATUS_REQUIRED),
      spouseName: yup
        .string()
        .trim()
        .when(
          "maritialStatus",
          (maritialStatus: any, schema: yup.StringSchema) => {
            const status = Array.isArray(maritialStatus)
              ? maritialStatus[0]
              : maritialStatus;

            if (
              status === "annulled marriage" ||
              status === "married" ||
              status === "common—law"
            ) {
              return schema.required(ValidationCons.SPOUSENAME_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      previouslyMarried: yup
        .string()
        .trim()
        .required(ValidationCons.PREVIOUSLYMARRIED_REQUIRED),
      previousSpouseName: yup.string().trim().optional(),
      // .required(ValidationCons.PREVIOUSSPOUSENAME_REQUIRED),
      previousSpouseDob: yup
        .string()
        .trim()
        .when(
          "previouslyMarried",
          (previouslyMarried: any, schema: yup.StringSchema) => {
            const status = Array.isArray(previouslyMarried)
              ? previouslyMarried[0]
              : previouslyMarried;

            if (status === "yes") {
              return schema.required(ValidationCons.PREVIOUSSPOUSEDOB_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      // .required(ValidationCons.PREVIOUSSPOUSEDOB_REQUIRED),
      typeOfRelationship: yup
        .string()
        .trim()
        .when(
          "previouslyMarried",
          (previouslyMarried: any, schema: yup.StringSchema) => {
            const status = Array.isArray(previouslyMarried)
              ? previouslyMarried[0]
              : previouslyMarried;

            if (status === "yes") {
              return schema.required(
                ValidationCons.TYPEOFRELATIONSHIP_REQUIRED
              );
            }
            return schema.notRequired();
          }
        ),
      // .required(ValidationCons.TYPEOFRELATIONSHIP_REQUIRED),
      previousSpouseFrom: yup
        .string()
        .trim()
        .when(
          "previouslyMarried",
          (previouslyMarried: any, schema: yup.StringSchema) => {
            const status = Array.isArray(previouslyMarried)
              ? previouslyMarried[0]
              : previouslyMarried;
            if (status === "yes") {
              return schema
                .required(ValidationCons.PREVIOUSSPOUSEFROM_REQUIRED)
                .test(
                  "from-after-dob",
                  ValidationCons.PREVIOUSSPOUSEFROM_LESSER_REQUIRED,
                  function (value) {
                    const { previousSpouseDob } = this.parent;
                    if (previousSpouseDob && value) {
                      return new Date(value) > new Date(previousSpouseDob);
                    }
                    return true;
                  }
                );
            }
            return schema.notRequired();
          }
        ),
      // .required(ValidationCons.PREVIOUSSPOUSEFROM_REQUIRED),
      previousSpouseTill: yup
        .string()
        .trim()
        .when(
          "previouslyMarried",
          (previouslyMarried: any, schema: yup.StringSchema) => {
            const status = Array.isArray(previouslyMarried)
              ? previouslyMarried[0]
              : previouslyMarried;
            if (status === "yes") {
              return schema
                .required(ValidationCons.PREVIOUSSPOUSEFROM_REQUIRED)
                .test(
                  "till-after-from",
                  ValidationCons.PREVIOUSSPOUSETILL_GREATERFROM_REQUIRED,
                  function (value) {
                    const { previousSpouseFrom } = this.parent;
                    if (previousSpouseFrom && value) {
                      return new Date(value) > new Date(previousSpouseFrom);
                    }
                    return true;
                  }
                );
            }
            return schema.notRequired();
          }
        ),
      // .required(ValidationCons.PREVIOUSSPOUSETILL_REQUIRED),
      languages: yup
        .string()
        .trim()
        .required(ValidationCons.LANGUAGES_REQUIRED),
      communicationFrench: yup
        .string()
        .trim()
        .required(ValidationCons.COMMUNICATIONFRENCH_REQUIRED),
      assessProficiency: yup
        .string()
        .trim()
        .required(ValidationCons.ASSESSPROFICIENCY_REQUIRED),
      passportNumber: yup
        .string()
        .trim()
        .matches(
          /^[A-Z0-9]{6,9}$/,
          ValidationCons.INVALID_PASSPORTNUMBER_FORMAT // Custom error message for invalid format
        )
        .required(ValidationCons.PASSPORTNUMBER_REQUIRED),
      countryOfPassportIssued: yup
        .string()
        .trim()
        .required(ValidationCons.COUNTRYOFPASSPORTISSUED_REQUIRED),
      issueDate: yup
        .string()
        .trim()
        .required(ValidationCons.ISSUEDATE_REQUIRED),
      expiryDate: yup
        .string()
        .trim()
        .required(ValidationCons.EXPIRYDATE_REQUIRED)
        .when("issueDate", (issueDate: any, schema: yup.StringSchema) => {
          const expiryDateValue = Array.isArray(issueDate)
            ? issueDate[0]
            : issueDate;
          if (expiryDateValue) {
            return schema.test(
              "till-after-from",
              ValidationCons.EXPIRYDATE_GREATER_REQUIRED,
              function (value) {
                const { issueDate } = this.parent;
                if (issueDate && value) {
                  return new Date(value) > new Date(issueDate);
                }
                return true;
              }
            );
          }
          return schema.notRequired();
        }),
      nationalDocumentNumber: yup
        .string()
        .trim()
        .required(ValidationCons.NATIONALDOCUMENTNUMBER_REQUIRED),
      nationalDocumentIssuer: yup
        .string()
        .trim()
        .required(ValidationCons.NATIONALDOCUMENTISSUER_REQUIRED),
      nationalDocumentIssueDate: yup
        .string()
        .trim()
        .required(ValidationCons.NATIONALDOCUMENTISSUEDATE_REQUIRED),
      nationalDocumentExpiryDate: yup
        .string()
        .trim()
        .required(ValidationCons.NATIONALDOCUMENTEXPIRYDATE_REQUIRED)
        .when(
          "nationalDocumentIssueDate",
          (nationalDocumentIssueDate: any, schema: yup.StringSchema) => {
            const expiryDateValue = Array.isArray(nationalDocumentIssueDate)
              ? nationalDocumentIssueDate[0]
              : nationalDocumentIssueDate;
            if (expiryDateValue) {
              return schema.test(
                "till-after-from",
                ValidationCons.EXPIRYDATE_GREATER_REQUIRED,
                function (value) {
                  const { nationalDocumentIssueDate } = this.parent;
                  if (nationalDocumentIssueDate && value) {
                    return (
                      new Date(value) > new Date(nationalDocumentIssueDate)
                    );
                  }
                  return true;
                }
              );
            }
            return schema.notRequired();
          }
        ),
      greenCard: yup
        .string()
        .trim()
        .required(ValidationCons.GREENCARD_REQUIRED),
      greenCardNumber: yup
        .string()
        .trim()
        .when("greenCard", (greenCard: any, schema: yup.StringSchema) => {
          const status = Array.isArray(greenCard) ? greenCard[0] : greenCard;
          if (status === "yes") {
            return schema.required(ValidationCons.GREENCARDNUMBER_REQUIRED);
          }
          return schema.notRequired();
        }),
      greenCardExpiry: yup
        .string()
        .trim()
        // .required(ValidationCons.GREENCARDEXPIRY_REQUIRED)
        .when("greenCard", (greenCard: any, schema: yup.StringSchema) => {
          const status = Array.isArray(greenCard) ? greenCard[0] : greenCard;
          if (status === "yes") {
            return schema.required(ValidationCons.GREENCARDEXPIRY_REQUIRED);
          }
          return schema.notRequired();
        }),
      contactStreet: yup
        .string()
        .trim()
        .required(ValidationCons.CONTACTSTREET_REQUIRED),
      contactCity: yup
        .string()
        .trim()
        .required(ValidationCons.CONTACTCITY_REQUIRED),
      contactCountry: yup
        .string()
        .trim()
        .required(ValidationCons.CONTACTCOUNTRY_REQUIRED),
      residentialAddressSame: yup
        .string()
        .trim()
        .required(ValidationCons.RESIDENTIALADDRESSSAME_REQUIRED),
      residentialStreet: yup
        .string()
        .trim()
        .required(ValidationCons.RESIDENTIALSTREET_REQUIRED),
      residentialCity: yup
        .string()
        .trim()
        .required(ValidationCons.RESIDENTIALCITY_REQUIRED),
      residentialCountry: yup
        .string()
        .trim()
        .required(ValidationCons.RESIDENTIALCOUNTRY_REQUIRED),
      telephone: yup.string().trim().optional(),
      // .required(ValidationCons.TELEPHONE_REQUIRED),
      contactType: yup
        .string()
        .trim()
        .required(ValidationCons.CONTACTTYPE_REQUIRED),
      contactCountryCode: yup.string().trim().optional(),
      // .required(ValidationCons.CONTACTCOUNTRYCODE_REQUIRED),
      contactNumber: yup.string().trim().optional(),
      // .required(ValidationCons.CONTACTNUMBER_REQUIRED),
      contactFax: yup.string().trim().optional(),
      // .required(ValidationCons.CONTACTFAX_REQUIRED),
      contactType2: yup
        .string()
        .trim()
        .required(ValidationCons.CONTACTTYPE2_REQUIRED),
      contactCountryCode2: yup.string().trim().optional(),
      // .required(ValidationCons.CONTACTCOUNTRYCODE2_REQUIRED),
      contactNumber2: yup.string().trim().optional(),
      // .required(ValidationCons.CONTACTNUMBER2_REQUIRED),
      contactEmail: yup.string().trim().optional(),
      // .required(ValidationCons.CONTACTEMAIL_REQUIRED),
      canadaVisitPurpose: yup
        .string()
        .trim()
        .required(ValidationCons.CANADAVISITPURPOSE_REQUIRED),
      canadaVisitedFrom: yup
        .string()
        .trim()
        .required(ValidationCons.CANADAVISITEDFROM_REQUIRED),
      canadaVisitedTill: yup
        .string()
        .trim()
        .required(ValidationCons.CANADAVISITEDTILL_REQUIRED),
      fundsAvailableCAD: yup.string().trim().optional(),
      // .required(ValidationCons.FUNDSAVAILABLECAD_REQUIRED),
      nameInCanada: yup.string().trim().optional(),
      // .required(ValidationCons.NAMEINCANADA_REQUIRED),
      addressInCanada: yup.string().trim().optional(),
      // .required(ValidationCons.ADDRESSINCANADA_REQUIRED),
      educationSecondary: yup
        .string()
        .trim()
        .required(ValidationCons.EDUCATIONSECONDARY_REQUIRED),
      educationStartedYear: yup
        .string()
        .trim()
        // .required(ValidationCons.EDUCATIONSTARTEDYEAR_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(
                ValidationCons.EDUCATIONSTARTEDYEAR_REQUIRED
              );
            }
            return schema.notRequired();
          }
        ),
      educationStartedMonth: yup
        .string()
        .trim()
        // .required(ValidationCons.EDUCATIONSTARTEDMONTH_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(
                ValidationCons.EDUCATIONSTARTEDMONTH_REQUIRED
              );
            }
            return schema.notRequired();
          }
        ),
      educationTillYear: yup
        .string()
        .trim()
        // .required(ValidationCons.EDUCATIONTILLYEAR_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(ValidationCons.EDUCATIONTILLYEAR_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      educationTillMonth: yup
        .string()
        .trim()
        // .required(ValidationCons.EDUCATIONTILLMONTH_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(
                ValidationCons.EDUCATIONTILLMONTH_REQUIRED
              );
            }
            return schema.notRequired();
          }
        ),
      fieldOfStudent: yup
        .string()
        .trim()
        // .required(ValidationCons.FIELDOFSTUDENT_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(ValidationCons.FIELDOFSTUDENT_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      schoolName: yup
        .string()
        .trim()
        // .required(ValidationCons.SCHOOLNAME_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(ValidationCons.SCHOOLNAME_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      schoolCity: yup
        .string()
        .trim()
        // .required(ValidationCons.SCHOOLCITY_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(ValidationCons.SCHOOLCITY_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      schoolCountry: yup
        .string()
        .trim()
        // .required(ValidationCons.SCHOOLCOUNTRY_REQUIRED),
        .when(
          "educationSecondary",
          (educationSecondary: any, schema: yup.StringSchema) => {
            const status = Array.isArray(educationSecondary)
              ? educationSecondary[0]
              : educationSecondary;

            if (status === "yes") {
              return schema.required(ValidationCons.SCHOOLCOUNTRY_REQUIRED);
            }
            return schema.notRequired();
          }
        ),
      employmentFromYear: yup
        .string()
        .trim()
        .required(ValidationCons.EMPLOYMENTFROMYEAR_REQUIRED),
      employmentFromMonth: yup
        .string()
        .trim()
        .required(ValidationCons.EMPLOYMENTFROMMONTH_REQUIRED),
      employmentToYear: yup
        .string()
        .trim()
        .required(ValidationCons.EMPLOYMENTTOYEAR_REQUIRED),
      employmentToMonth: yup
        .string()
        .trim()
        .required(ValidationCons.EMPLOYMENTTOMONTH_REQUIRED),
      currentOccupation: yup
        .string()
        .trim()
        .required(ValidationCons.CURRENTOCCUPATION_REQUIRED),
      currentCompanyName: yup
        .string()
        .trim()
        .required(ValidationCons.CURRENTCOMPANYNAME_REQUIRED),
      currentCompanyCity: yup
        .string()
        .trim()
        .required(ValidationCons.CURRENTCOMPANYCITY_REQUIRED),
      currentCompanyCountry: yup
        .string()
        .trim()
        .required(ValidationCons.CURRENTCOMPANYCOUNTRY_REQUIRED),
      tbInLast2Years: yup.string().trim().optional(),
      // .required(ValidationCons.TBINLAST2YEARS_REQUIRED),
      physicalMentalDisorder: yup.string().trim().optional(),
      // .required(ValidationCons.PHYSICALMENTALDISORDER_REQUIRED),
      nameOfFamilyMember: yup
        .string()
        .trim()
        .when(["tbInLast2Years", "physicalMentalDisorder"], {
          is: (tbInLast2Years: string, physicalMentalDisorder: string) => {
            // console.log(tbInLast2Years, physicalMentalDisorder); // Debugging log
            return tbInLast2Years === "yes" || physicalMentalDisorder === "yes";
          },
          then: (schema) =>
            schema.required(ValidationCons.NAMEOFFAMILYMEMBER_REQUIRED),
          otherwise: (schema) => schema.notRequired(),
        }),
      withoutAuthorization: yup.string().trim().optional(),
      // .required(ValidationCons.WITHOUTAUTHORIZATION_REQUIRED),
      visaDenied: yup.string().trim().optional(),
      // .required(ValidationCons.VISADENIED_REQUIRED),
      previouslyApplied: yup.string().trim().optional(),
      // .required(ValidationCons.PREVIOUSLYAPPLIED_REQUIRED),
      yes2abcDetials: yup
        .string()
        .trim()
        .when(["withoutAuthorization", "visaDenied", "previouslyApplied"], {
          is: (
            withoutAuthorization: string,
            visaDenied: string,
            previouslyApplied: string
          ) => {
            // console.log(tbInLast2Years, physicalMentalDisorder); // Debugging log
            return (
              withoutAuthorization === "yes" ||
              visaDenied === "yes" ||
              previouslyApplied === "yes"
            );
          },
          then: (schema) =>
            schema.required(ValidationCons.YES2ABCDETIALS_REQUIRED),
          otherwise: (schema) => schema.notRequired(),
        }),
      criminalOffence: yup.string().trim().optional(),
      // .required(ValidationCons.CRIMINALOFFENCE_REQUIRED),
      criminalDetails: yup
        .string()
        .trim()
        .when(["criminalOffence"], {
          is: (criminalOffence: string) => {
            return criminalOffence === "yes";
          },
          then: (schema) =>
            schema.required(ValidationCons.CRIMINALDETAILS_REQUIRED),
          otherwise: (schema) => schema.notRequired(),
        }),
      militaryVoluntary: yup.string().trim().optional(),
      // .required(ValidationCons.MILITARYVOLUNTARY_REQUIRED),
      detailsVoluntaryServed: yup
        .string()
        .trim()
        .when(["militaryVoluntary"], {
          is: (militaryVoluntary: string) => {
            return militaryVoluntary === "yes";
          },
          then: (schema) =>
            schema.required(ValidationCons.DETAILSVOLUNTARYSERVED_REQUIRED),
          otherwise: (schema) => schema.notRequired(),
        }),
      associatedWithPoliticalParty: yup.string().trim().optional(),
      // .required(ValidationCons.ASSOCIATEDWITHPOLITICALPARTY_REQUIRED),
      witnessedCivilians: yup.string().trim().optional(),
      // .required(ValidationCons.WITNESSEDCIVILIANS_REQUIRED),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);

      try {
        delete values["isResidentialSame"];
        // console.log(user?._id,values,15454);
        
        const response = await updateImmigrationDetails(user?._id, values);
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages === "Immegration request added successfully") {
            showError(ValidationCons.REQUEST_IMMIGRATION_SUBMIT);
            dispatch(updateImmigration(user));
            NavigateTo(AppRoute.JOBSEEKER_DASHBOARD);
          } else {
            showError(response && response.message);
          }
        }
      } catch (error) {
        setLoading(false);
        showError(error);
      }
    },
  });

  const handleErrorScroll = () => {
    const firstErrorField = Object.keys(RequestImmegrationik.errors)[0];
    if (firstErrorField) {
      const element = document.querySelector<HTMLInputElement>(
        `[name="${firstErrorField}"]`
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
  };

  const handleSubmitWithErrorScroll = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    await RequestImmegrationik.validateForm();
    if (Object.keys(RequestImmegrationik.errors).length > 0) {
      handleErrorScroll();
    } else {
      RequestImmegrationik.handleSubmit(e);
    }
  };

  function handleResidentialAddressSame(
    e: React.ChangeEvent<HTMLInputElement>,
    RequestImmegrationik: any
  ) {
    const isSame = e.target.value === "yes";
    if (isSame) {
      RequestImmegrationik.setFieldValue(
        "residentialStreet",
        RequestImmegrationik.values.contactStreet
      );
      RequestImmegrationik.setFieldValue(
        "residentialCity",
        RequestImmegrationik.values.contactCity
      );
      RequestImmegrationik.setFieldValue(
        "residentialCountry",
        RequestImmegrationik.values.contactCountry
      );
    } else {
      RequestImmegrationik.setFieldValue("residentialStreet", "");
      RequestImmegrationik.setFieldValue("residentialCity", "");
      RequestImmegrationik.setFieldValue("residentialCountry", "AND");
    }
    RequestImmegrationik.setFieldValue("isResidentialSame", isSame);
    RequestImmegrationik.handleChange(e);
  }
  const handleNumericInput = (
    e: React.ChangeEvent<any>, // Accept any type here
    maxLength: number,
    formikSetField: (field: string, value: any) => void
  ) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length <= maxLength) {
      formikSetField(e.target.name, value);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (RequestImmegrationik.values.isResidentialSame) {
      RequestImmegrationik.setFieldValue(
        "residentialStreet",
        RequestImmegrationik.values.contactStreet
      );
      RequestImmegrationik.setFieldValue(
        "residentialCity",
        RequestImmegrationik.values.contactCity
      );
      RequestImmegrationik.setFieldValue(
        "residentialCountry",
        RequestImmegrationik.values.contactCountry
      );
    }
    // eslint-disable-next-line
  }, [
    RequestImmegrationik.values.contactStreet,
    RequestImmegrationik.values.contactCity,
    RequestImmegrationik.values.contactCountry,
  ]);

  useEffect(() => {
    if (
      RequestImmegrationik.values.tbInLast2Years === "no" &&
      RequestImmegrationik.values.physicalMentalDisorder === "no"
    ) {
      RequestImmegrationik.setFieldValue("nameOfFamilyMember", "");
    }
    // eslint-disable-next-line
  }, [
    RequestImmegrationik.values.tbInLast2Years,
    RequestImmegrationik.values.physicalMentalDisorder,
  ]);

  useEffect(() => {
    if (
      RequestImmegrationik.values.withoutAuthorization === "no" &&
      RequestImmegrationik.values.visaDenied === "no" &&
      RequestImmegrationik.values.previouslyApplied === "no"
    ) {
      RequestImmegrationik.setFieldValue("yes2abcDetials", "");
    }
    // eslint-disable-next-line
  }, [
    RequestImmegrationik.values.withoutAuthorization,
    RequestImmegrationik.values.visaDenied,
    RequestImmegrationik.values.previouslyApplied,
  ]);

  useEffect(() => {
    if (RequestImmegrationik.values.criminalOffence === "no") {
      RequestImmegrationik.setFieldValue("criminalDetails", "");
    }
    // eslint-disable-next-line
  }, [RequestImmegrationik.values.criminalOffence]);

  useEffect(() => {
    if (RequestImmegrationik.values.militaryVoluntary === "no") {
      RequestImmegrationik.setFieldValue("detailsVoluntaryServed", "");
    }
    // eslint-disable-next-line
  }, [RequestImmegrationik.values.militaryVoluntary]);

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                <SidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <TopHeadScreen />
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12 filterHolder pt-3 mb-4">
                      <div className="filterResults">
                        <div className="title">
                          <h2>Request Immigration</h2>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <Form onSubmit={handleSubmitWithErrorScroll}>
                              <div className="row">
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>I want service in *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="serviceIn"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.serviceIn
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .serviceIn &&
                                        Boolean(
                                          RequestImmegrationik.touched.serviceIn
                                        )
                                      }
                                    >
                                      <option value="English">English</option>
                                      <option value="French">French</option>
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .serviceIn === "string" &&
                                        RequestImmegrationik.errors.serviceIn}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>visa requested *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="visaRequested"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .visaRequested
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .visaRequested &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .visaRequested
                                        )
                                      }
                                    >
                                      <option value="visitor visa">
                                        Visitor Visa
                                      </option>
                                      <option value="transit">Transit</option>
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .visaRequested === "string" &&
                                        RequestImmegrationik.errors
                                          .visaRequested}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Full name *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Family name (as shown on your passport or travel document)"
                                      name="fullName"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.fullName
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .fullName &&
                                        Boolean(
                                          RequestImmegrationik.touched.fullName
                                        )
                                      }
                                    />

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .fullName === "string" &&
                                        RequestImmegrationik.errors.fullName}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Sex *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="sex"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={RequestImmegrationik.values.sex}
                                      isInvalid={
                                        !!RequestImmegrationik.errors.sex &&
                                        Boolean(
                                          RequestImmegrationik.touched.sex
                                        )
                                      }
                                    >
                                      <option value="F">F Female</option>
                                      <option value="M">M Male</option>
                                      <option value="U">U Unknown</option>
                                      <option value="X">
                                        X Another gender
                                      </option>
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .sex === "string" &&
                                        RequestImmegrationik.errors.sex}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Date of Birth *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="dateOfBirth"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.dateOfBirth
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .dateOfBirth &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .dateOfBirth
                                        )
                                      }
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                    />

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .dateOfBirth === "string" &&
                                        RequestImmegrationik.errors.dateOfBirth}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Place of birth </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="CitY/Town *"
                                      name="placeOfBirth"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.placeOfBirth
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .placeOfBirth &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .placeOfBirth
                                        )
                                      }
                                    />

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .placeOfBirth === "string" &&
                                        RequestImmegrationik.errors
                                          .placeOfBirth}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>
                                      Country or Territory *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="countryOrTerritory"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .countryOrTerritory
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .countryOrTerritory &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .countryOrTerritory
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .countryOrTerritory === "string" &&
                                        RequestImmegrationik.errors
                                          .countryOrTerritory}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Citizenship *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="citizenship"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.citizenship
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .citizenship &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .citizenship
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .citizenship === "string" &&
                                        RequestImmegrationik.errors.citizenship}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>
                                      Current Country or Territory of residence:
                                      *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="currentCountry"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .currentCountry
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .currentCountry &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .currentCountry
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .currentCountry === "string" &&
                                        RequestImmegrationik.errors
                                          .currentCountry}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Status *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="citizenStatus"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .citizenStatus
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .citizenStatus &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .citizenStatus
                                        )
                                      }
                                    >
                                      <option value="citizen">Citizen</option>
                                      <option value="permanent resident">
                                        Permanent resident
                                      </option>
                                      <option value="visitor">Visitor</option>
                                      <option value="worker">Worker</option>
                                      <option value="student">Student</option>
                                      <option value="other">Other</option>
                                      <option value="protected person">
                                        Protected Person
                                      </option>
                                      <option value="refugee claimant">
                                        Refugee Claimant
                                      </option>
                                      <option value="foreign national">
                                        {" "}
                                        Foreign National
                                      </option>
                                    </Form.Select>

                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .citizenStatus === "string" &&
                                        RequestImmegrationik.errors
                                          .citizenStatus}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Previous countries or territory of
                                      residence: <br />
                                      <span>
                                        {" "}
                                        During the past five years have you
                                        lived in any country or territory other
                                        than your country of citizenship or your
                                        current country or territory of
                                        residence (indicated above) for more
                                        than six months?
                                      </span>
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        name="previousTerritoryDifferent"
                                        value={"yes"}
                                        checked={
                                          RequestImmegrationik.values
                                            .previousTerritoryDifferent ===
                                          "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .previousTerritoryDifferent &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .previousTerritoryDifferent
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        name="previousTerritoryDifferent"
                                        value={"no"}
                                        checked={
                                          RequestImmegrationik.values
                                            .previousTerritoryDifferent === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .previousTerritoryDifferent &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .previousTerritoryDifferent
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .previousTerritoryDifferent ===
                                        "string" &&
                                        RequestImmegrationik.errors
                                          .previousTerritoryDifferent}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>
                                      Your current maritial status *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="maritialStatus"
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        RequestImmegrationik.handleChange(e);
                                        if (
                                          value === "annulled marriage" ||
                                          value === "married" ||
                                          value === "common—law"
                                        ) {
                                          setShowSpouseName(true);
                                        } else {
                                          setShowSpouseName(false);
                                          RequestImmegrationik.setFieldValue(
                                            "spouseName",
                                            ""
                                          );
                                        }
                                      }}
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .maritialStatus &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .maritialStatus
                                        )
                                      }
                                    >
                                      <option value="annulled marriage">
                                        Annulled Marriage
                                      </option>
                                      <option value="common—law">
                                        Common—Law
                                      </option>
                                      <option value="divorced">Divorced</option>
                                      <option value="legally separated">
                                        Legally Separated
                                      </option>
                                      <option value="married">Married</option>
                                      <option value="single">Single</option>
                                      <option value="unknown">Unknown</option>
                                      <option value="widowed">Widowed</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .maritialStatus === "string" &&
                                        RequestImmegrationik.errors
                                          .maritialStatus}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                {showSpouseName && (
                                  <div className="col-lg-6">
                                    <Form.Group className="form-group mb-4">
                                      <Form.Label>
                                        Provide the name of your current
                                        Spouse/Common-Iaw partner *
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="*Spouse name"
                                        name="spouseName"
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        value={
                                          RequestImmegrationik.values.spouseName
                                        }
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .spouseName &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .spouseName
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .spouseName === "string" &&
                                          RequestImmegrationik.errors
                                            .spouseName}
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </div>
                                )}

                                <div className="col-lg-12">
                                  <h3>PERSONAL DETAILS (CONTINUED)</h3>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Have you previously been married or in a
                                      common-law relationship? *
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        name="previouslyMarried"
                                        value="yes"
                                        checked={
                                          RequestImmegrationik.values
                                            .previouslyMarried === "yes"
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          RequestImmegrationik.handleChange(e);
                                          if (value === "yes") {
                                            setPreviouslyMarried(true);
                                          } else {
                                            setPreviouslyMarried(false);

                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseName",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseDob",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "typeOfRelationship",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseTill",
                                              ""
                                            );
                                          }
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .previouslyMarried &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .previouslyMarried
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        name="previouslyMarried"
                                        value="no"
                                        checked={
                                          RequestImmegrationik.values
                                            .previouslyMarried === "no"
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          RequestImmegrationik.handleChange(e);
                                          if (value === "yes") {
                                            setPreviouslyMarried(true);
                                          } else {
                                            setPreviouslyMarried(false);

                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseName",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseDob",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "typeOfRelationship",
                                              "common-law"
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseFrom",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "previousSpouseTill",
                                              ""
                                            );
                                          }
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .previouslyMarried &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .previouslyMarried
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .previouslyMarried === "string" &&
                                          RequestImmegrationik.errors
                                            .previouslyMarried}
                                      </Form.Control.Feedback>
                                    </div>
                                  </Form.Group>
                                </div>
                                {previouslyMarried && (
                                  <>
                                    <div className="col-lg-6">
                                      <Form.Group className="form-group mb-4">
                                        <Form.Label>
                                          Provide the following details for your
                                          previous Spouse/Common-law Partner:
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          placeholder="*Previous Spouse name"
                                          name="previousSpouseName"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .previousSpouseName
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .previousSpouseName &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .previousSpouseName
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .previousSpouseName === "string" &&
                                            RequestImmegrationik.errors
                                              .previousSpouseName}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-3">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>Date of Birth *</Form.Label>
                                        <Form.Control
                                          type="date"
                                          placeholder="DD MM YYYY"
                                          name="previousSpouseDob"
                                          max={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .previousSpouseDob
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .previousSpouseDob &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .previousSpouseDob
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .previousSpouseDob === "string" &&
                                            RequestImmegrationik.errors
                                              .previousSpouseDob}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-3">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>
                                          Type of relationship *
                                        </Form.Label>
                                        <Form.Select
                                          className="form-control"
                                          aria-label="Default select example"
                                          name="typeOfRelationship"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .typeOfRelationship
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .typeOfRelationship &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .typeOfRelationship
                                            )
                                          }
                                        >
                                          <option value="common-law">
                                            Common-Law
                                          </option>
                                          <option value="married">
                                            Married
                                          </option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .typeOfRelationship === "string" &&
                                            RequestImmegrationik.errors
                                              .typeOfRelationship}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-3">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>From *</Form.Label>
                                        <Form.Control
                                          type="date"
                                          placeholder="DD MM YYYY"
                                          name="previousSpouseFrom"
                                          max={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .previousSpouseFrom
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .previousSpouseFrom &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .previousSpouseFrom
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .previousSpouseFrom === "string" &&
                                            RequestImmegrationik.errors
                                              .previousSpouseFrom}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-3">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>To *</Form.Label>
                                        <Form.Control
                                          type="date"
                                          placeholder="DD MM YYYY"
                                          name="previousSpouseTill"
                                          max={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .previousSpouseTill
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .previousSpouseTill &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .previousSpouseTill
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .previousSpouseTill === "string" &&
                                            RequestImmegrationik.errors
                                              .previousSpouseTill}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                  </>
                                )}

                                <div className="col-lg-12">
                                  <h3>LANGUAGE(S)</h3>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>
                                      Native language/Mother Tongue *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="languages"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .languages &&
                                        Boolean(
                                          RequestImmegrationik.touched.languages
                                        )
                                      }
                                    >
                                      {Object.entries(languages).map(
                                        ([code, { name }]) => (
                                          <option key={code} value={code}>
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .languages === "string" &&
                                        RequestImmegrationik.errors.languages}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>
                                      Are you able to communicate in English
                                      and/or French? *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="communicationFrench"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .communicationFrench &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .communicationFrench
                                        )
                                      }
                                    >
                                      <option value="english">English</option>
                                      <option value="french">French</option>
                                      <option value="neither">Neither</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .communicationFrench === "string" &&
                                        RequestImmegrationik.errors
                                          .communicationFrench}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Have you taken a test from a designated
                                      testing agency to assess your proficiency
                                      in English or French? *
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="assessProficiency"
                                        checked={
                                          RequestImmegrationik.values
                                            .assessProficiency === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .assessProficiency &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .assessProficiency
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="assessProficiency"
                                        checked={
                                          RequestImmegrationik.values
                                            .assessProficiency === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .assessProficiency &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .assessProficiency
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .assessProficiency === "string" &&
                                        RequestImmegrationik.errors
                                          .assessProficiency}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <h3>PASSPORT</h3>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Passport number *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="passportNumber"
                                      maxLength={9}
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .passportNumber
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .passportNumber &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .passportNumber
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .passportNumber === "string" &&
                                        RequestImmegrationik.errors
                                          .passportNumber}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Country or territory of issue *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="countryOfPassportIssued"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .countryOfPassportIssued &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .countryOfPassportIssued
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .countryOfPassportIssued === "string" &&
                                        RequestImmegrationik.errors
                                          .countryOfPassportIssued}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Issue date *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="issueDate"
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.issueDate
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .issueDate &&
                                        Boolean(
                                          RequestImmegrationik.touched.issueDate
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .issueDate === "string" &&
                                        RequestImmegrationik.errors.issueDate}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Expiry date *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="expiryDate"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.expiryDate
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .expiryDate &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .expiryDate
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .expiryDate === "string" &&
                                        RequestImmegrationik.errors.expiryDate}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <h3>NATIONAL IDENTITY DOCUMENT</h3>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Do you have a national identity document?
                                      *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Document number"
                                      name="nationalDocumentNumber"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .nationalDocumentNumber
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .nationalDocumentNumber &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .nationalDocumentNumber
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .nationalDocumentNumber === "string" &&
                                        RequestImmegrationik.errors
                                          .nationalDocumentNumber}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Country or territory of issue *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="nationalDocumentIssuer"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .nationalDocumentIssuer &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .nationalDocumentIssuer
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .nationalDocumentIssuer === "string" &&
                                        RequestImmegrationik.errors
                                          .nationalDocumentIssuer}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Issue date *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="nationalDocumentIssueDate"
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .nationalDocumentIssueDate
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .nationalDocumentIssueDate &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .nationalDocumentIssueDate
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .nationalDocumentIssueDate ===
                                        "string" &&
                                        RequestImmegrationik.errors
                                          .nationalDocumentIssueDate}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>Expiry date *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="nationalDocumentExpiryDate"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .nationalDocumentExpiryDate
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .nationalDocumentExpiryDate &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .nationalDocumentExpiryDate
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .nationalDocumentExpiryDate ===
                                        "string" &&
                                        RequestImmegrationik.errors
                                          .nationalDocumentExpiryDate}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <h3>US PR CARD</h3>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Are you a lawful Permanent Resident of the
                                      United States with a valid alien
                                      registration card (green card)? *
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="greenCard"
                                        checked={
                                          RequestImmegrationik.values
                                            .greenCard === "yes"
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          RequestImmegrationik.handleChange(e);
                                          if (value === "yes") {
                                            setHaveGreenCard(true);
                                          } else {
                                            setHaveGreenCard(false);
                                            RequestImmegrationik.setFieldValue(
                                              "greenCardNumber",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "greenCardExpiry",
                                              ""
                                            );
                                          }
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .greenCard &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .greenCard
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="greenCard"
                                        checked={
                                          RequestImmegrationik.values
                                            .greenCard === "no"
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          RequestImmegrationik.handleChange(e);
                                          if (value === "yes") {
                                            setHaveGreenCard(true);
                                          } else {
                                            setHaveGreenCard(false);
                                            RequestImmegrationik.setFieldValue(
                                              "greenCardNumber",
                                              ""
                                            );
                                            RequestImmegrationik.setFieldValue(
                                              "greenCardExpiry",
                                              ""
                                            );
                                          }
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .greenCard &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .greenCard
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .greenCard === "string" &&
                                          RequestImmegrationik.errors.greenCard}
                                      </Form.Control.Feedback>
                                    </div>
                                  </Form.Group>
                                </div>
                                {haveGreenCard && (
                                  <>
                                    <div className="col-lg-6">
                                      <Form.Group className="form-group mb-4">
                                        <Form.Label>
                                          Document number *
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          placeholder="Document number"
                                          name="greenCardNumber"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .greenCardNumber
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .greenCardNumber &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .greenCardNumber
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .greenCardNumber === "string" &&
                                            RequestImmegrationik.errors
                                              .greenCardNumber}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>Expiry date *</Form.Label>
                                        <Form.Control
                                          type="date"
                                          placeholder="DD MM YYYY"
                                          name="greenCardExpiry"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          min={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .greenCardExpiry
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .greenCardExpiry &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .greenCardExpiry
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .greenCardExpiry === "string" &&
                                            RequestImmegrationik.errors
                                              .greenCardExpiry}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                  </>
                                )}
                                <div className="col-lg-12">
                                  <h3>CONTACT INFORMATION</h3>
                                  <h4>
                                    If submitting your application by mail:
                                  </h4>
                                  <ul className="mb-3">
                                    <li>
                                      - All correspondence will go to this
                                      address unless you indicate your e-mail
                                      address below.
                                    </li>
                                    <li>
                                      - Indicating an e-mail address will
                                      authorize all correspondence, including
                                      file and personal information, to be sent
                                      to the e-mail address you specify.
                                    </li>
                                    <li>
                                      - If you wish to authorize the release of
                                      information from your application to a
                                      representative, indicate their e-mail and
                                      mailing address(es) in this section and on
                                      the IMM5476 form.
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Street name *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="contactStreet"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .contactStreet
                                      }
                                      onBlur={(e) => {
                                        RequestImmegrationik.handleBlur(e);
                                      }}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactStreet &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactStreet
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactStreet === "string" &&
                                        RequestImmegrationik.errors
                                          .contactStreet}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>City Town *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="contactCity"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values.contactCity
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactCity &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactCity
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactCity === "string" &&
                                        RequestImmegrationik.errors.contactCity}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Country or Territory *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="contactCountry"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .contactCountry
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactCountry &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactCountry
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactCountry === "string" &&
                                        RequestImmegrationik.errors
                                          .contactCountry}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Residential address{" "}
                                      <span>Same as mailing address?</span> *
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="residentialAddressSame"
                                        checked={
                                          RequestImmegrationik.values
                                            .residentialAddressSame === "yes"
                                        }
                                        onChange={(e) =>
                                          handleResidentialAddressSame(
                                            e,
                                            RequestImmegrationik
                                          )
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .residentialAddressSame &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .residentialAddressSame
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="residentialAddressSame"
                                        checked={
                                          RequestImmegrationik.values
                                            .residentialAddressSame === "no"
                                        }
                                        onChange={(e) =>
                                          handleResidentialAddressSame(
                                            e,
                                            RequestImmegrationik
                                          )
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .residentialAddressSame &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .residentialAddressSame
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .residentialAddressSame === "string" &&
                                        RequestImmegrationik.errors
                                          .residentialAddressSame}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Street name *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="residentialStreet"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .residentialStreet
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .residentialStreet &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .residentialStreet
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .residentialStreet === "string" &&
                                        RequestImmegrationik.errors
                                          .residentialStreet}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>City Town *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="residentialCity"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .residentialCity
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .residentialCity &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .residentialCity
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .residentialCity === "string" &&
                                        RequestImmegrationik.errors
                                          .residentialCity}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Country or Territory *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="residentialCountry"
                                      onChange={(e) => {
                                        RequestImmegrationik.handleChange(e);
                                      }}
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .residentialCountry
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .residentialCountry &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .residentialCountry
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .residentialCountry === "string" &&
                                        RequestImmegrationik.errors
                                          .residentialCountry}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Telephone no.</Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Canada/US "
                                        name="telephone"
                                        value="canada/us"
                                        checked={
                                          RequestImmegrationik.values
                                            .telephone === "canada/us"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .telephone &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .telephone
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="Other"
                                        name="telephone"
                                        value="other"
                                        checked={
                                          RequestImmegrationik.values
                                            .telephone === "other"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .telephone &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .telephone
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .telephone === "string" &&
                                        RequestImmegrationik.errors.telephone}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Type *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="contactType"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactType &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactType
                                        )
                                      }
                                    >
                                      <option value="residence">
                                        Residence
                                      </option>
                                      <option value="cellular">Cellular</option>
                                      <option value="business">Business</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactType === "string" &&
                                        RequestImmegrationik.errors.contactType}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-2">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Country Code</Form.Label>
                                    <Form.Control
                                      type="number"
                                      placeholder="1"
                                      name="contactCountryCode"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .contactCountryCode
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactCountryCode &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactCountryCode
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactCountryCode === "string" &&
                                        RequestImmegrationik.errors
                                          .contactCountryCode}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Your Number"
                                      name="contactNumber"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .contactNumber
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactNumber &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactNumber
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactNumber === "string" &&
                                        RequestImmegrationik.errors
                                          .contactNumber}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Fax no.</Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Canada/US "
                                        value={"canada/us"}
                                        name="contactFax"
                                        checked={
                                          RequestImmegrationik.values
                                            .contactFax === "canada/us"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .contactFax &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .contactFax
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="Other"
                                        value={"other"}
                                        name="contactFax"
                                        checked={
                                          RequestImmegrationik.values
                                            .contactFax === "other"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .contactFax &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .contactFax
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactFax === "string" &&
                                        RequestImmegrationik.errors.contactFax}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Type *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="contactType2"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactType2 &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactType2
                                        )
                                      }
                                    >
                                      <option value="residence">
                                        Residence
                                      </option>
                                      <option value="cellular">Cellular</option>
                                      <option value="business">Business</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactType2 === "string" &&
                                        RequestImmegrationik.errors
                                          .contactType2}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-2">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Country Code</Form.Label>
                                    <Form.Control
                                      type="number"
                                      placeholder="1"
                                      name="contactCountryCode2"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .contactCountryCode2
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactCountryCode2 &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactCountryCode2
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactCountryCode2 === "string" &&
                                        RequestImmegrationik.errors
                                          .contactCountryCode2}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Your Number"
                                      name="contactNumber2"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .contactNumber2
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactNumber2 &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactNumber2
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactNumber2 === "string" &&
                                        RequestImmegrationik.errors
                                          .contactNumber2}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>E-mail address</Form.Label>
                                    <Form.Control
                                      type="email"
                                      placeholder="Enter Your Email"
                                      name="contactEmail"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.contactEmail
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .contactEmail &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .contactEmail
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .contactEmail === "string" &&
                                        RequestImmegrationik.errors
                                          .contactEmail}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>

                                <div className="col-lg-12">
                                  <h3>DETAILS OF VISIT TO CANADA</h3>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Purpose of visit *</Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="canadaVisitPurpose"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .canadaVisitPurpose &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .canadaVisitPurpose
                                        )
                                      }
                                    >
                                      <option value={"business"}>
                                        Business
                                      </option>
                                      <option value={"tourism"}>Tourism</option>
                                      <option value={"short-term studies"}>
                                        Short-Term Studies
                                      </option>
                                      <option value={"family visit"}>
                                        Family Visit
                                      </option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .canadaVisitPurpose === "string" &&
                                        RequestImmegrationik.errors
                                          .canadaVisitPurpose}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>From *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="canadaVisitedFrom"
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .canadaVisitedFrom
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .canadaVisitedFrom &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .canadaVisitedFrom
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .canadaVisitedFrom === "string" &&
                                        RequestImmegrationik.errors
                                          .canadaVisitedFrom}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>To *</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="DD MM YYYY"
                                      name="canadaVisitedTill"
                                      // max={new Date().toISOString().split('T')[0]}
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .canadaVisitedTill
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .canadaVisitedTill &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .canadaVisitedTill
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .canadaVisitedTill === "string" &&
                                        RequestImmegrationik.errors
                                          .canadaVisitedTill}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Funds available form sta (CAD)
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="fundsAvailableCAD"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .fundsAvailableCAD
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .fundsAvailableCAD &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .fundsAvailableCAD
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .fundsAvailableCAD === "string" &&
                                        RequestImmegrationik.errors
                                          .fundsAvailableCAD}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="nameInCanada"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values.nameInCanada
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .nameInCanada &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .nameInCanada
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .nameInCanada === "string" &&
                                        RequestImmegrationik.errors
                                          .nameInCanada}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>Address in Canada</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="addressInCanada"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .addressInCanada
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .addressInCanada &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .addressInCanada
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .addressInCanada === "string" &&
                                        RequestImmegrationik.errors
                                          .addressInCanada}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <h3>EDUCATION</h3>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Have you had any post secondary education
                                      (including university, college or
                                      apprenticeship training)?
                                      <br />
                                      If you answered "yes", give full details
                                      of your highest level of post secondary
                                      education.
                                    </Form.Label>
                                    <div className="checkgroup ">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="educationSecondary"
                                        checked={
                                          RequestImmegrationik.values
                                            .educationSecondary === "yes"
                                        }
                                        onChange={(e) => {
                                          RequestImmegrationik.handleChange(e);
                                          setHavePostSecondaryEducation(true);
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .educationSecondary &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .educationSecondary
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="educationSecondary"
                                        checked={
                                          RequestImmegrationik.values
                                            .educationSecondary === "no"
                                        }
                                        onChange={(e) => {
                                          RequestImmegrationik.handleChange(e);
                                          setHavePostSecondaryEducation(false);
                                          RequestImmegrationik.setFieldValue(
                                            "educationStartedYear",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "educationStartedMonth",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "educationTillYear",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "educationTillMonth",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "fieldOfStudent",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "schoolName",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "schoolCity",
                                            ""
                                          );
                                          RequestImmegrationik.setFieldValue(
                                            "schoolCountry",
                                            "AND"
                                          );
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .educationSecondary &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .educationSecondary
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .educationSecondary === "string" &&
                                        RequestImmegrationik.errors
                                          .educationSecondary}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                {havePostSecondaryEducation && (
                                  <>
                                    <div className="col-lg-3">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>From *</Form.Label>
                                        <div className="d-flex flex-btn">
                                          <Form.Control
                                            type="text"
                                            placeholder="*YYYY"
                                            name="educationStartedYear"
                                            onChange={(e) =>
                                              handleNumericInput(
                                                e,
                                                4,
                                                RequestImmegrationik.setFieldValue
                                              )
                                            }
                                            onBlur={
                                              RequestImmegrationik.handleBlur
                                            }
                                            value={
                                              RequestImmegrationik.values
                                                .educationStartedYear
                                            }
                                            maxLength={4}
                                            isInvalid={
                                              !!RequestImmegrationik.errors
                                                .educationStartedYear &&
                                              Boolean(
                                                RequestImmegrationik.touched
                                                  .educationStartedYear
                                              )
                                            }
                                          />
                                          {/* <Form.Control.Feedback type="invalid">
                                            {typeof RequestImmegrationik.errors
                                              .educationStartedYear ===
                                              "string" &&
                                              RequestImmegrationik.errors
                                                .educationStartedYear}
                                          </Form.Control.Feedback> */}
                                          <Form.Control
                                            type="text"
                                            placeholder="*MM"
                                            name="educationStartedMonth"
                                            onChange={(e) =>
                                              handleNumericInput(
                                                e,
                                                2,
                                                RequestImmegrationik.setFieldValue
                                              )
                                            }
                                            onBlur={
                                              RequestImmegrationik.handleBlur
                                            }
                                            value={
                                              RequestImmegrationik.values
                                                .educationStartedMonth
                                            }
                                            isInvalid={
                                              !!RequestImmegrationik.errors
                                                .educationStartedMonth &&
                                              Boolean(
                                                RequestImmegrationik.touched
                                                  .educationStartedMonth
                                              )
                                            }
                                          />
                                          {/* <Form.Control.Feedback type="invalid">
                                            {typeof RequestImmegrationik.errors
                                              .educationStartedMonth ===
                                              "string" &&
                                              RequestImmegrationik.errors
                                                .educationStartedMonth}
                                          </Form.Control.Feedback> */}
                                        </div>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-3">
                                      <Form.Group className="form-group  mb-4">
                                        <Form.Label>To *</Form.Label>
                                        <div className="d-flex flex-btn">
                                          <Form.Control
                                            type="text"
                                            placeholder="*YYYY"
                                            name="educationTillYear"
                                            onChange={(e) =>
                                              handleNumericInput(
                                                e,
                                                4,
                                                RequestImmegrationik.setFieldValue
                                              )
                                            }
                                            onBlur={
                                              RequestImmegrationik.handleBlur
                                            }
                                            value={
                                              RequestImmegrationik.values
                                                .educationTillYear
                                            }
                                            isInvalid={
                                              !!RequestImmegrationik.errors
                                                .educationTillYear &&
                                              Boolean(
                                                RequestImmegrationik.touched
                                                  .educationTillYear
                                              )
                                            }
                                          />
                                          {/* <Form.Control.Feedback type="invalid">
                                            {typeof RequestImmegrationik.errors
                                              .educationTillYear === "string" &&
                                              RequestImmegrationik.errors
                                                .educationTillYear}
                                          </Form.Control.Feedback> */}
                                          <Form.Control
                                            type="text"
                                            placeholder="*MM"
                                            name="educationTillMonth"
                                            onChange={(e) =>
                                              handleNumericInput(
                                                e,
                                                2,
                                                RequestImmegrationik.setFieldValue
                                              )
                                            }
                                            onBlur={
                                              RequestImmegrationik.handleBlur
                                            }
                                            value={
                                              RequestImmegrationik.values
                                                .educationTillMonth
                                            }
                                            isInvalid={
                                              !!RequestImmegrationik.errors
                                                .educationTillMonth &&
                                              Boolean(
                                                RequestImmegrationik.touched
                                                  .educationTillMonth
                                              )
                                            }
                                          />
                                          {/* <Form.Control.Feedback type="invalid">
                                            {typeof RequestImmegrationik.errors
                                              .educationTillMonth ===
                                              "string" &&
                                              RequestImmegrationik.errors
                                                .educationTillMonth}
                                          </Form.Control.Feedback> */}
                                        </div>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                      <Form.Group className="form-group mb-4">
                                        <Form.Label>
                                          Field of Student *
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          placeholder=""
                                          name="fieldOfStudent"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .fieldOfStudent
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .fieldOfStudent &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .fieldOfStudent
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .fieldOfStudent === "string" &&
                                            RequestImmegrationik.errors
                                              .fieldOfStudent}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-4">
                                      <Form.Group className="form-group mb-4">
                                        <Form.Label>
                                          School/Facility name *
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          placeholder=""
                                          name="schoolName"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .schoolName
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .schoolName &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .schoolName
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .schoolName === "string" &&
                                            RequestImmegrationik.errors
                                              .schoolName}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-4">
                                      <Form.Group className="form-group mb-4">
                                        <Form.Label>City town *</Form.Label>
                                        <Form.Control
                                          type="text"
                                          placeholder=""
                                          name="schoolCity"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          value={
                                            RequestImmegrationik.values
                                              .schoolCity
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .schoolCity &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .schoolCity
                                            )
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .schoolCity === "string" &&
                                            RequestImmegrationik.errors
                                              .schoolCity}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                    <div className="col-lg-4">
                                      <Form.Group className="form-group mb-4">
                                        <Form.Label>
                                          Country or Territory *
                                        </Form.Label>
                                        <Form.Select
                                          className="form-control"
                                          aria-label="Default select example"
                                          name="schoolCountry"
                                          onChange={
                                            RequestImmegrationik.handleChange
                                          }
                                          onBlur={
                                            RequestImmegrationik.handleBlur
                                          }
                                          isInvalid={
                                            !!RequestImmegrationik.errors
                                              .schoolCountry &&
                                            Boolean(
                                              RequestImmegrationik.touched
                                                .schoolCountry
                                            )
                                          }
                                        >
                                          {Object.entries(countries).map(
                                            ([code, { name }]) => (
                                              <option
                                                key={code}
                                                value={
                                                  (
                                                    countries2to3 as Record<
                                                      string,
                                                      string
                                                    >
                                                  )[code]
                                                }
                                              >
                                                {name}
                                              </option>
                                            )
                                          )}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                          {typeof RequestImmegrationik.errors
                                            .schoolCountry === "string" &&
                                            RequestImmegrationik.errors
                                              .schoolCountry}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>
                                  </>
                                )}
                                <div className="col-lg-12">
                                  <h3>EMPLOYMENT</h3>
                                  <p>
                                    Give details of your employment for the past
                                    10 years, including if you have held any
                                    government positions (such as civil servant,
                                    judge, police officer, mayor, Member of
                                    Parliament, hospital dministrator, employee
                                    of a security organization). Do not leave
                                    gaps. If retired, not working or studying,
                                    please indicate. If you are retired, please
                                    provide the 10 years before you retirement.
                                  </p>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>From *</Form.Label>
                                    <div className="d-flex flex-btn">
                                      <Form.Control
                                        type="text"
                                        placeholder="*YYYY"
                                        name="employmentFromYear"
                                        onChange={(e) =>
                                          handleNumericInput(
                                            e,
                                            4,
                                            RequestImmegrationik.setFieldValue
                                          )
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        value={
                                          RequestImmegrationik.values
                                            .employmentFromYear
                                        }
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .employmentFromYear &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .employmentFromYear
                                          )
                                        }
                                      />
                                      {/* <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .employmentFromYear === "string" &&
                                          RequestImmegrationik.errors
                                            .employmentFromYear}
                                      </Form.Control.Feedback> */}
                                      <Form.Control
                                        type="text"
                                        placeholder="*MM"
                                        name="employmentFromMonth"
                                        onChange={(e) =>
                                          handleNumericInput(
                                            e,
                                            2,
                                            RequestImmegrationik.setFieldValue
                                          )
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        value={
                                          RequestImmegrationik.values
                                            .employmentFromMonth
                                        }
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .employmentFromMonth &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .employmentFromMonth
                                          )
                                        }
                                      />
                                      {/* <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .employmentFromMonth === "string" &&
                                          RequestImmegrationik.errors
                                            .employmentFromMonth}
                                      </Form.Control.Feedback> */}
                                    </div>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-3">
                                  <Form.Group className="form-group  mb-4">
                                    <Form.Label>To *</Form.Label>
                                    <div className="d-flex flex-btn">
                                      <Form.Control
                                        type="text"
                                        placeholder="*YYYY"
                                        name="employmentToYear"
                                        onChange={(e) =>
                                          handleNumericInput(
                                            e,
                                            4,
                                            RequestImmegrationik.setFieldValue
                                          )
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        value={
                                          RequestImmegrationik.values
                                            .employmentToYear
                                        }
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .employmentToYear &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .employmentToYear
                                          )
                                        }
                                      />
                                      {/* <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .employmentToYear === "string" &&
                                          RequestImmegrationik.errors
                                            .employmentToYear}
                                      </Form.Control.Feedback> */}
                                      <Form.Control
                                        type="text"
                                        placeholder="*MM"
                                        name="employmentToMonth"
                                        onChange={(e) =>
                                          handleNumericInput(
                                            e,
                                            2,
                                            RequestImmegrationik.setFieldValue
                                          )
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        value={
                                          RequestImmegrationik.values
                                            .employmentToMonth
                                        }
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .employmentToMonth &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .employmentToMonth
                                          )
                                        }
                                      />
                                      {/* <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .employmentToMonth === "string" &&
                                          RequestImmegrationik.errors
                                            .employmentToMonth}
                                      </Form.Control.Feedback> */}
                                    </div>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Current Activity /Occupation *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="currentOccupation"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .currentOccupation
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .currentOccupation &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .currentOccupation
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .currentOccupation === "string" &&
                                        RequestImmegrationik.errors
                                          .currentOccupation}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Company/Employer/Facility name *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="currentCompanyName"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      value={
                                        RequestImmegrationik.values
                                          .currentCompanyName
                                      }
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .currentCompanyName &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .currentCompanyName
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .currentCompanyName === "string" &&
                                        RequestImmegrationik.errors
                                          .currentCompanyName}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>City town *</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      name="currentCompanyCity"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .currentCompanyCity
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .currentCompanyCity &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .currentCompanyCity
                                        )
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .currentCompanyCity === "string" &&
                                        RequestImmegrationik.errors
                                          .currentCompanyCity}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Country or Territory *
                                    </Form.Label>
                                    <Form.Select
                                      className="form-control"
                                      aria-label="Default select example"
                                      name="currentCompanyCountry"
                                      onChange={
                                        RequestImmegrationik.handleChange
                                      }
                                      value={
                                        RequestImmegrationik.values
                                          .currentCompanyCountry
                                      }
                                      onBlur={RequestImmegrationik.handleBlur}
                                      isInvalid={
                                        !!RequestImmegrationik.errors
                                          .currentCompanyCountry &&
                                        Boolean(
                                          RequestImmegrationik.touched
                                            .currentCompanyCountry
                                        )
                                      }
                                    >
                                      {Object.entries(countries).map(
                                        ([code, { name }]) => (
                                          <option
                                            key={code}
                                            value={
                                              (
                                                countries2to3 as Record<
                                                  string,
                                                  string
                                                >
                                              )[code]
                                            }
                                          >
                                            {name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .currentCompanyCountry === "string" &&
                                        RequestImmegrationik.errors
                                          .currentCompanyCountry}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-12">
                                  <h3>BACKGROUND INFORMATION</h3>
                                  <h4>
                                    You must complete this section if you are 18
                                    years of age or older.
                                  </h4>
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      a) Within the past two years, have you or
                                      a family member ever had tuberculosis of
                                      the lungs or been in close contact with a
                                      person with tuberculosis?
                                    </Form.Label>
                                    <div className="checkgroup ">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="tbInLast2Years"
                                        checked={
                                          RequestImmegrationik.values
                                            .tbInLast2Years === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .tbInLast2Years &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .tbInLast2Years
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="tbInLast2Years"
                                        checked={
                                          RequestImmegrationik.values
                                            .tbInLast2Years === "no"
                                        }
                                        onChange={(e) => {
                                          RequestImmegrationik.handleChange(e);
                                          RequestImmegrationik.setFieldValue(
                                            "nameOfFamilyMember",
                                            ""
                                          );
                                        }}
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .tbInLast2Years &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .tbInLast2Years
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .tbInLast2Years === "string" &&
                                        RequestImmegrationik.errors
                                          .tbInLast2Years}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      b) Do you have any physical or mental
                                      disorder that would require social and/or
                                      health services, other than medication,
                                      during a stay in Canada?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="physicalMentalDisorder"
                                        checked={
                                          RequestImmegrationik.values
                                            .physicalMentalDisorder === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .physicalMentalDisorder &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .physicalMentalDisorder
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="physicalMentalDisorder"
                                        checked={
                                          RequestImmegrationik.values
                                            .physicalMentalDisorder === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .physicalMentalDisorder &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .physicalMentalDisorder
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .physicalMentalDisorder === "string" &&
                                        RequestImmegrationik.errors
                                          .physicalMentalDisorder}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  {(RequestImmegrationik.values
                                    .tbInLast2Years === "yes" ||
                                    RequestImmegrationik.values
                                      .physicalMentalDisorder === "yes") && (
                                    <Form.Group className="form-group mb-4">
                                      <Form.Label>
                                        c) If you answered "yes" to question 1
                                        a) or 1 b), please provide details and
                                        the name of the family member (if
                                        applicable).
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        placeholder="Do you have any question?"
                                        name="nameOfFamilyMember"
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        value={
                                          RequestImmegrationik.values
                                            .nameOfFamilyMember
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .nameOfFamilyMember &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .nameOfFamilyMember
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .nameOfFamilyMember === "string" &&
                                          RequestImmegrationik.errors
                                            .nameOfFamilyMember}
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  )}
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      a) Have you ever remained beyond the
                                      validity of your status, attended school
                                      without authorization or worked without
                                      authorization in Canada?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="withoutAuthorization"
                                        checked={
                                          RequestImmegrationik.values
                                            .withoutAuthorization === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .withoutAuthorization &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .withoutAuthorization
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="withoutAuthorization"
                                        checked={
                                          RequestImmegrationik.values
                                            .withoutAuthorization === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .withoutAuthorization &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .withoutAuthorization
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .withoutAuthorization === "string" &&
                                        RequestImmegrationik.errors
                                          .withoutAuthorization}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      b) Have you ever been refused a visa or
                                      permit, denied entry or ordered to leave
                                      Canada or any other country or territory?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="visaDenied"
                                        checked={
                                          RequestImmegrationik.values
                                            .visaDenied === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .visaDenied &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .visaDenied
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="visaDenied"
                                        checked={
                                          RequestImmegrationik.values
                                            .visaDenied === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .visaDenied &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .visaDenied
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .visaDenied === "string" &&
                                        RequestImmegrationik.errors.visaDenied}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      c) Have you previously applied to enter or
                                      remain in Canada?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="previouslyApplied"
                                        checked={
                                          RequestImmegrationik.values
                                            .previouslyApplied === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .previouslyApplied &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .previouslyApplied
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="previouslyApplied"
                                        checked={
                                          RequestImmegrationik.values
                                            .previouslyApplied === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .previouslyApplied &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .previouslyApplied
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .previouslyApplied === "string" &&
                                        RequestImmegrationik.errors
                                          .previouslyApplied}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  {(RequestImmegrationik.values
                                    .withoutAuthorization === "yes" ||
                                    RequestImmegrationik.values.visaDenied ===
                                      "yes" ||
                                    RequestImmegrationik.values
                                      .previouslyApplied === "yes") && (
                                    <Form.Group className="form-group mb-4">
                                      <Form.Label>
                                        d) If you answered "yes" to question
                                        2a), 2b), or 2C please provide details.
                                        *
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        placeholder="Do you have any question?"
                                        name="yes2abcDetials"
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        value={
                                          RequestImmegrationik.values
                                            .yes2abcDetials
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .yes2abcDetials &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .yes2abcDetials
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .yes2abcDetials === "string" &&
                                          RequestImmegrationik.errors
                                            .yes2abcDetials}
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  )}
                                  {
                                    //dd?sdf:setvalue()
                                  }
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      a) Have you ever committed, been arrested
                                      for, been charged with or convicted of any
                                      criminal offence in any country or
                                      territory?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="criminalOffence"
                                        checked={
                                          RequestImmegrationik.values
                                            .criminalOffence === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .criminalOffence &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .criminalOffence
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="criminalOffence"
                                        checked={
                                          RequestImmegrationik.values
                                            .criminalOffence === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .criminalOffence &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .criminalOffence
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .criminalOffence === "string" &&
                                        RequestImmegrationik.errors
                                          .criminalOffence}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  {RequestImmegrationik.values
                                    .criminalOffence === "yes" && (
                                    <Form.Group className="form-group mb-4">
                                      <Form.Label>
                                        b) If you answered "yes" to question 3a)
                                        above, please provide details.
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        placeholder="Do you have any question?"
                                        name="criminalDetails"
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        value={
                                          RequestImmegrationik.values
                                            .criminalDetails
                                        }
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .criminalDetails &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .criminalDetails
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .criminalDetails === "string" &&
                                          RequestImmegrationik.errors
                                            .criminalDetails}
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  )}
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      a) Did you serve in any military, militia,
                                      or civil defence unit or serve in a
                                      security organization or police force
                                      (including non obligatory national
                                      service, reserve or volunteer units)?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="militaryVoluntary"
                                        checked={
                                          RequestImmegrationik.values
                                            .militaryVoluntary === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .militaryVoluntary &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .militaryVoluntary
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="militaryVoluntary"
                                        checked={
                                          RequestImmegrationik.values
                                            .militaryVoluntary === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .militaryVoluntary &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .militaryVoluntary
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .militaryVoluntary === "string" &&
                                        RequestImmegrationik.errors
                                          .militaryVoluntary}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  {RequestImmegrationik.values
                                    .militaryVoluntary === "yes" && (
                                    <Form.Group className="form-group mb-4">
                                      <Form.Label>
                                        b) If you answered yes to question 4a),
                                        please provide dates of service and
                                        countries or territories where you
                                        served.
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        placeholder="Do you have any question?"
                                        name="detailsVoluntaryServed"
                                        value={
                                          RequestImmegrationik.values
                                            .detailsVoluntaryServed
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .detailsVoluntaryServed &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .detailsVoluntaryServed
                                          )
                                        }
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {typeof RequestImmegrationik.errors
                                          .detailsVoluntaryServed ===
                                          "string" &&
                                          RequestImmegrationik.errors
                                            .detailsVoluntaryServed}
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  )}
                                </div>
                                <div className="col-lg-12">
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Are you, or have you ever been a member or
                                      associated with any political party, or
                                      other group or organization which has
                                      engaged in or advocated violence as a
                                      means to achieving a political or
                                      religious objective, or which has been
                                      associated with criminal activity at any
                                      time?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="associatedWithPoliticalParty"
                                        checked={
                                          RequestImmegrationik.values
                                            .associatedWithPoliticalParty ===
                                          "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .associatedWithPoliticalParty &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .associatedWithPoliticalParty
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="associatedWithPoliticalParty"
                                        checked={
                                          RequestImmegrationik.values
                                            .associatedWithPoliticalParty ===
                                          "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .associatedWithPoliticalParty &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .associatedWithPoliticalParty
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .associatedWithPoliticalParty ===
                                        "string" &&
                                        RequestImmegrationik.errors
                                          .associatedWithPoliticalParty}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                  <Form.Group className="form-group mb-4">
                                    <Form.Label>
                                      Have you ever witnessed or participated in
                                      the ill treatment of prisoners or
                                      civilians, looting or desecration of
                                      religious buildings?
                                    </Form.Label>
                                    <div className="checkgroup">
                                      <Form.Check
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="witnessedCivilians"
                                        checked={
                                          RequestImmegrationik.values
                                            .witnessedCivilians === "yes"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .witnessedCivilians &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .witnessedCivilians
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="witnessedCivilians"
                                        checked={
                                          RequestImmegrationik.values
                                            .witnessedCivilians === "no"
                                        }
                                        onChange={
                                          RequestImmegrationik.handleChange
                                        }
                                        onBlur={RequestImmegrationik.handleBlur}
                                        isInvalid={
                                          !!RequestImmegrationik.errors
                                            .witnessedCivilians &&
                                          Boolean(
                                            RequestImmegrationik.touched
                                              .witnessedCivilians
                                          )
                                        }
                                      />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                      {typeof RequestImmegrationik.errors
                                        .witnessedCivilians === "string" &&
                                        RequestImmegrationik.errors
                                          .witnessedCivilians}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>

                                <div className="col-lg-12">
                                  <Form.Group className="form-group">
                                    <Button className="btn" type="submit">
                                      {!loading ? `Submit` : `Submitting...`}
                                    </Button>
                                  </Form.Group>
                                </div>
                              </div>
                            </Form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default RequestImmigrationFormScreen;
